angular.module('charts')
  .directive("classroomsList", function() {
      return {
          restrict: "E",
          scope: {
          },
          transclude: true,
          templateUrl: '/resources/charts/partials/classrooms-list.html',
          controller: ['$scope', '$element', '$state', '$timeout', function($scope, $element, $state, $timeout) {

              var classroomSelectName =  "Select a Classroom";
              var classroomSearchName =  "Search for a classroom...";
              var defaultClassroom = { name: classroomSelectName, id: -1};
              $scope.classroomSearchName = classroomSearchName;
              $scope.classrooms = { list: [], selected: defaultClassroom };

              var updateQueryParams = function() {
                  var classroomId = $scope.classrooms.selected ? $scope.classrooms.selected.id : undefined;
                  $state.go('.', {'classroomId': classroomId}, {location: 'replace', notify: false});
              };

              $scope.$on('classroomsLoaded', function(e, data) {
                  $scope.classrooms.list = _.sortBy(angular.copy(data), function(classroom){return classroom.name;});

                  var params = $state.params;

                  if(params.classroomId) {
                      $scope.classrooms.selected = _.findWhere($scope.classrooms.list, { id: parseInt(params.classroomId) });
                  } else {
                      $scope.classrooms.selected = $scope.classrooms.list[0];
                      updateQueryParams();
                  }

                  // Ensure a classroom displays
                  if (_.isUndefined($scope.classrooms.selected)) {
                      $scope.classrooms.selected = defaultClassroom;
                  }
              });

              $scope.classroomClicked = function(classroom) {
                  $scope.classrooms.selected = classroom;
                  updateQueryParams();

                  $timeout(function() {
                      $scope.$emit('classroomsListUpdated');
                  });
              };
          }]
      };
  });
